// src/components/QRCode/index.tsx
import { useEffect } from 'react';
import { useQRCode } from '@/hooks/useQRCode';
import { QRStyleConfig } from '@/utils/qrcode/types';

interface QRCodeProps extends QRStyleConfig {
    className?: string;
    style?: React.CSSProperties;
}

export const QRCode = ({ className, style, ...config }: QRCodeProps) => {
    const { containerRef, updateQR } = useQRCode(config);

    useEffect(() => {
        updateQR(config);
    }, [
        config.value,
        config.dotsOptions?.color,
        config.dotsOptions?.type,
        config.cornersSquareOptions?.color,
        config.cornersSquareOptions?.type,
        config.cornersDotOptions?.color,
        config.cornersDotOptions?.type,
        config.backgroundOptions?.color,
        config.image,
        config.imageOptions?.hideBackgroundDots,
        config.imageOptions?.imageSize,
        config.imageOptions?.margin,
        config.imageOptions?.crossOrigin,
        updateQR
    ]);

    return (
        <div 
            ref={containerRef} 
            className={className}
            style={style}
        />
    );
};